"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormHint", {
    enumerable: true,
    get: function() {
        return FormHint;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormHint = (param)=>{
    let { hint, error, id } = param;
    const { colors, spacers } = (0, _Theme.useTheme)();
    const hasError = error != null && error !== "";
    const hasHint = hint != null && hint !== "";
    const show = hasError || hasHint;
    return !show ? null : /*#__PURE__*/ _react.default.createElement("p", {
        id: id,
        className: _style.default.dynamic([
            [
                "87e68e1f30bdeaa",
                [
                    hasError ? colors.danger : colors.dark,
                    spacers.s3,
                    hasError ? "uppercase" : "none"
                ]
            ]
        ])
    }, hasError ? error : hasHint ? hint : null, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "87e68e1f30bdeaa",
        dynamic: [
            hasError ? colors.danger : colors.dark,
            spacers.s3,
            hasError ? "uppercase" : "none"
        ]
    }, "p.__jsx-style-dynamic-selector{font-size:13px;color:".concat(hasError ? colors.danger : colors.dark, ";margin:").concat(spacers.s3, " 0}p.__jsx-style-dynamic-selector:first-letter{text-transform:").concat(hasError ? "uppercase" : "none", "}")));
};

//# sourceMappingURL=FormHint.js.map